import React, { useEffect, useRef, useState } from "react";
import {
  UpdateTrack,
  deleteHostingTracks,
  modernizeTrack,
  visibileHostingTracks,
} from "../../../../core/Services";
import { Card, CardHeader, Flex, Heading } from "@chakra-ui/react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast"; 
import { Dialog } from "primereact/dialog";
import { Calendar } from "primereact/calendar";
import { addLocale } from "primereact/api";
import { Dropdown } from "primereact/dropdown";
import { useSelector } from "react-redux";
import { InputText } from "primereact/inputtext";
import { ARCHIVE_MODE_ENABLED } from "../../../../archive/archiveConfig";
function useInterval(callback, delay) {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function tick() {
      savedCallback.current();
    }

    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

export default function Hosting() {
  const [tally, setTally] = useState([]);
  const [addModal, setAddModal] = useState(false);
  const [service_type] = useState("1");
  const [customerList, setCustomerList] = useState([]);
  const [cus, setCus] = useState("");
  const [domainName, setDomainName] = useState("");
  const [owner, setOwner] = useState("");
  const [platform, setPlatform] = useState("");
  const [startingDate, setStartingDate] = useState(null);
  const [renewalDate, setRenewalDate] = useState(null);
  const [dialogs, setDialogs] = useState({});
  const [selectedTask, setSelectedTask] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedName, setSelectedName] = useState(null);
  const [visibilityDialog, setVisibilityDialog] = useState(false);
  const [displayDeleteDialog, setDisplayDeleteDialog] = useState(false);
  const tallyData = useSelector((state) => state.TallyReduce.value);
   const toast = useRef(null);
   const [inputErrors, setInputErrors] = useState({
     domainName: false,
     startingDate: false,
     renewalDate: false,
   });

  const filterHostName = (value) => {
    let matchingObjects = [];
    if (Array.isArray(tallyData.tracks) && tallyData.tracks.length > 0) {
      matchingObjects = tallyData.tracks.filter((item) =>
        item.domain_name.includes(value)
      );
    }
    setTally(matchingObjects);
  };
  useInterval(() => {
    setTally((prevTally) => {
      // Eğer prevTally boşsa veya kalan süre bilgisi yoksa, güncelleme yapma
      if (!prevTally || !prevTally.length) {
        return prevTally;
      }

      const updatedTally = prevTally.map((item) => {
        const remainingDays = calculateRemainingDays(
          item.renewal_date,
          item.starting_date
        );
        return {
          ...item,
          remainingDays,
        };
      });

      return updatedTally;
    });
  }, 24 * 60 * 60 * 1000);

  const formatDate = (dateString) => {
    const options = {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    };
    return new Date(dateString).toLocaleString("tr-TR", options);
  };
  addLocale("tr", {
    firstDayOfWeek: 1,
    showMonthAfterYear: true,
    dayNames: [
      "pazar",
      "pazartesi",
      "salı",
      "çarşamba",
      "perşembe",
      "cuma",
      "cumartesi",
    ],
    dayNamesShort: ["paz", "pzt", "sal", "çar", "per", "cum", "cmt"],
    dayNamesMin: ["P", "Pzt", "S", "Ç", "P", "C", "Cmt"],
    monthNames: [
      "ocak",
      "şubat",
      "mart",
      "nisan",
      "mayıs",
      "haziran",
      "temmuz",
      "ağustos",
      "eylül",
      "ekim",
      "kasım",
      "aralık",
    ],
    monthNamesShort: [
      "oca",
      "şub",
      "mar",
      "nis",
      "may",
      "haz",
      "tem",
      "ağu",
      "eyl",
      "eki",
      "kas",
      "ara",
    ],
    today: "Bugün",
    clear: "Temizle",
  });

  const isButtonDisable = false;

  const hideDialog = () => {
    setDomainName("");
    setStartingDate(null);
    setCus(null);
    setRenewalDate(null);
    setAddModal(false);
  };

  const newCreate = async () => {

    if (
      
      !domainName ||
      !startingDate ||
      !renewalDate 
     ) {
      setInputErrors({
   
        domainName: !domainName,
        startingDate: !startingDate,
        renewalDate: !renewalDate,
       
      });
      toast.current.show({
        severity: "error",
        summary: "Hata",
        detail: "Lütfen boş kısımları doldurun.",
      });
      return;
    }
    const formattedStartingDate = formatDate(startingDate);
    const formattedRenewalDate = formatDate(renewalDate);

    await UpdateTrack(
      service_type,
      domainName,
      platform,
      cus,
      owner,
      formattedStartingDate,
      formattedRenewalDate
    );
    setAddModal(false);

    setDomainName("");
    setCus("");
    setOwner("");
    setPlatform("");
    setStartingDate(null);
    setRenewalDate(null);
    setAddModal(false);
    
  };

  const calculateRemainingDays = (renewalDate, startingDate) => {
    const ONE_DAY = 24 * 60 * 60 * 1000; // 1 günün milisaniye cinsinden değeri
    const renewalDateObject = new Date(renewalDate);
    const startingDateObject = new Date();

    // İki tarih arasındaki gün farkını hesapla
    const timeDiff = renewalDateObject - startingDateObject;
    const daysDiff = Math.ceil(timeDiff / ONE_DAY);

    return daysDiff;
  };

  useEffect(() => {
    if (tallyData) {
      const sortedData = [...tallyData?.tracks].sort((a, b) => {
        const remainingDaysA = calculateRemainingDays(a.renewal_date);
        const remainingDaysB = calculateRemainingDays(b.renewal_date);
        return remainingDaysA - remainingDaysB;
      });
      setTally(sortedData);
      setCustomerList(tallyData.customers);
    }
  }, [tallyData, dialogs]);

  const handleCompleteTask = async () => {
    try {
      if (!selectedTask) {
        console.error("Düzenlenecek görev bulunamadı.");
        return;
      }

      const formattedStartingDate = formatDate(startingDate);
      const formattedRenewalDate = formatDate(renewalDate);

      await modernizeTrack(
        selectedTask.id,
        domainName,
        platform,
        cus,
        owner,
        formattedStartingDate,
        formattedRenewalDate
      );
      setDialogs(false);
    } catch (error) {
      console.error("Hata:", error.message);
    }
  };
  const hideDeleteDialog = () => {
    setDisplayDeleteDialog(false);
    setSelectedId(null);
  };

  const handleDeletedHosting = async () => {
    await deleteHostingTracks(selectedId, selectedName);
    setDisplayDeleteDialog(false);
    setSelectedId(null);
  };

  const EditBodyTemplate = (tasks) => {
    const isVisible = dialogs[tasks.id] || false;

    useEffect(() => {
      if (isVisible) {
        setDomainName(tasks.domain_name || "");
        setPlatform(tasks.platform || "");
        setCus(
          customerList.find((dept) => dept.id.toString() === tasks.customer)
            ?.id || ""
        );

        setOwner(tasks.owner || "");
        const startingDateValue = tasks.starting_date
          ? new Date(tasks.starting_date)
          : new Date();
        const renewalDateValue = tasks.renewal_date
          ? new Date(tasks.renewal_date)
          : new Date();

        setStartingDate(startingDateValue);
        setRenewalDate(renewalDateValue);
      }
    }, [isVisible, tasks]);

    return (
      <React.Fragment>
        <div style={{ display: "flex" }}>
          <div style={{ color: "#f39f5a" }}>
            <Button
              severity="warning"
              onClick={() => {
                setSelectedTask(tasks); // Seçilen görevi state'e kaydet
                setDialogs((prevDialogs) => ({
                  ...prevDialogs,
                  [tasks.id]: true, // Görevin visible state'ini true yap
                }));
              }}
              icon="pi pi-pencil"
            />
          </div>
          <div style={{ color: "#ae445a" }}>
            <Button
              icon="pi pi-trash"
              onClick={() => {
                setDomainName(tasks?.domain_name);
                setSelectedId(tasks.id);
                 if (tasks?.customer) {
                   const customer = customerList.find(
                     (dept) => dept.id.toString() === tasks.customer
                   );

                   if (customer) {
                     const fullName = customer.title;
                     const splittedName = fullName.split(" ");
                     const firstTwoWords = splittedName.slice(0, 2).join(" ");
                     setCus(firstTwoWords);
                   } else {
                     setCus("Bilinmeyen");
                   }
                 }
                setSelectedName(tasks.domain_name);
                setDisplayDeleteDialog(true);
              }}
              severity="danger"
            />
          </div>
          <div style={{ color: "#00d9ff" }}>
            <Button
              icon="pi pi-clone"
              onClick={() => {
                setSelectedId(tasks.id);
                setVisibilityDialog(true);
              }}
              severity="info"
            />
          </div>
        </div>
        <Dialog
          header="İçerik Düzenleme"
          visible={isVisible}
          style={{ width: "50vw" }}
          onHide={() => {
            setDialogs((prevDialogs) => ({
              ...prevDialogs,
              [tasks.id]: false,
            }));
            setSelectedTask(null);
          }}
          footer={
            <div>
              <Button
                label="Kaydet"
                icon="pi pi-check"
                onClick={handleCompleteTask}
                className="btn-excel-two"
                style={{ width:"9rem" }}
              />
            </div>
          }
        >
          <div className="confirmation-content">
            <div className="p-grid p-fluid">
              <Calendar
                placeholder="İlk Kayıt Tarihi"
                className="w-full"
                locale="tr"
                style={{
                  border: "1px solid gray",
                  padding: "0.5rem",
                  width: "65%",
                  marginBottom: "1rem",
                  borderRadius: "6px 6px 6px 6px",
                }}
                value={startingDate || null}
                onChange={(e) => setStartingDate(e.value)}
                dateFormat="dd/mm/yy"
                showTime={false}
                firstDayOfWeek={1}
              />

              <Calendar
                placeholder="Yenileme Tarihi"
                className="w-full"
                locale="tr"
                style={{
                  border: "1px solid gray",

                  padding: "0.5rem",
                  marginBottom: "1rem",
                  borderRadius: "6px 6px 6px 6px",
                }}
                value={renewalDate}
                onChange={(e) => setRenewalDate(e.value)}
                dateFormat="dd/mm/yy"
                showTime={false}
                firstDayOfWeek={1}
              />
            </div>
          </div>
        </Dialog>
      </React.Fragment>
    );
  };
  const handleCloseDialog = () => {
    setVisibilityDialog(false);
  };
  const handleCompleteVisibile = async () => {
    try {
      if (!selectedId) {
        console.error("Pasife alınacak domain bulunamadı.");
        return;
      }
      await visibileHostingTracks(selectedId);
      setVisibilityDialog(false);
    } catch (error) {
      console.error("Hata:", error.message);
    }
  };

  return (
    <Flex mt="5" justifyContent="center" alignItems="center">
      <div
        className="card"
        style={{
          overflow: "auto",
          boxSizing: "border-box",
          width: "100%",
          height: "100%",
          position: "relative",
          padding: "1rem",
        }}
      >
        <Card>
          <CardHeader>
            <Flex justifyContent="space-between" alignItems="center">
              <Heading size="md">Hosting</Heading>
              <div>
                <span
                  className="p-input-icon-right"
                  style={{
                    border: "solid 1px gray",
                    borderRadius: "6px 6px 6px 6px",
                    padding: "0.2rem",
                  }}
                >
                  <i className="pi pi-search" />
                  <InputText
                    placeholder="Alan Adı Ara"
                    onChange={(e) => filterHostName(e.target.value)}
                  />
                </span>
                {!ARCHIVE_MODE_ENABLED && (
                  <Button
                    label="Yeni"
                    style={{ marginLeft: "1rem" }}
                    onClick={() => setAddModal(true)}
                    className="btn-excel-two"
                  />
                )}
              </div>
            </Flex>
          </CardHeader>
          <DataTable
            stripedRows
            size="small"
            dataKey="id"
            tableStyle={{ minWidth: "50rem" }}
            rows={15}
            value={
              tally &&
              Array.isArray(tally) &&
              tally.filter(
                (item) =>
                  item?.service_type === "1" && item?.hosting_visibility === "0"
              )
            }
            rowsPerPageOptions={[15, 30, 60, 100]}
            scrollHeight="65vh"
            scrollable
            paginator
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate=" {totalRecords} hostingden {first} - {last} arası gösteriliyor"
          >
            {!ARCHIVE_MODE_ENABLED && (
              <Column
                style={{ width: "8rem" }}
                body={EditBodyTemplate}
                header="İşlemler"
              ></Column>
            )}
            <Column field="domain_name" header="Alan Adı"></Column>
            <Column
              field="customer"
              header="Müşteri Adı"
              body={(rowData) => {
                const customer = customerList.find(
                  (dept) => dept.id.toString() === rowData.customer
                );

                if (customer) {
                  const fullName = customer.title;
                  const splittedName = fullName.split(" ");
                  const firstTwoWords = splittedName.slice(0, 2).join(" ");
                  return firstTwoWords;
                } else {
                  return "Bilinmeyen";
                }
              }}
            ></Column>
            <Column
              field="starting_date"
              header="İlk Kayıt Tarihi"
              body={(rowData) => formatDate(rowData.starting_date)}
            ></Column>
            <Column
              field="renewal_date"
              header="Yenileme Tarihi"
              body={(rowData) => formatDate(rowData.renewal_date)}
            ></Column>
            <Column
              header="Kalan Süre"
              body={(rowData) => {
                const remainingDays = calculateRemainingDays(
                  rowData.renewal_date
                );

                // Kalan günler 0'dan küçükse ve rowData.id mevcutsa, updateTimeStopTrack fonksiyonunu çağır
                // if (remainingDays < 0 && rowData.id) {
                //   updateTimeStopTrack(rowData.id);
                // }
                let backgroundColor;
                let textColor;

                if (remainingDays >= 30) {
                  backgroundColor = "#4CAF50"; // Yeşil tonu
                  textColor = "black";
                } else if (remainingDays >= 7) {
                  backgroundColor = "#FFC107"; // Sarı tonu
                  textColor = "black";
                } else {
                  backgroundColor = "#F44336"; // Kırmızı tonu
                  textColor = "black";
                }

                const style = {
                  backgroundColor,
                  borderRadius: "5px",
                  color: textColor,
                  padding: "5px",
                  display: "inline-block",
                };

                return <span style={style}>{remainingDays} gün</span>;
              }}
            ></Column>
          </DataTable>
        </Card>
      </div>
      <Dialog
        visible={addModal}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        style={{ width: "50%" }}
        header="Hosting Ekle"
        onHide={hideDialog}
        modal
      >
        <div className="confirmation-content">
          <div className="p-grid p-fluid">
            <div className="p-col-12">
              <div style={{ marginBottom: "1rem" }}>
                <Dropdown
                  filter
                  options={
                    tally &&
                    Array.isArray(tally) &&
                    tally
                      .filter(
                        (data) =>
                          data.service_type === "0" &&
                          data.hosting_domain_status === "0"
                      )
                      .map((data) => ({
                        label: data.domain_name,
                        value: data.domain_name,
                      }))
                  }
                  placeholder="Alan Adı"
                  style={{
                    border: "1px solid gray",
                  }}
                  className="w-full"
                  value={domainName}
                  onChange={(e) => {
                    setDomainName(e.target.value);
                    setInputErrors({ ...inputErrors, domainName: false });
                  }}
                />
                {inputErrors.domainName && (
                  <small style={{ color: "red" }}>
                    Lütfen alan adı giriniz .
                  </small>
                )}
              </div>

              <div style={{ marginBottom: "1rem" }}>
                <Calendar
                  placeholder="İlk Kayıt Tarihi"
                  locale="tr"
                  style={{
                    border: "1px solid gray",
                    padding: "0.5rem",

                    marginBottom: "1rem",
                    borderRadius: "6px 6px 6px 6px",
                  }}
                  value={startingDate}
                  onChange={(e) => {
                    setStartingDate(e.value);
                    setInputErrors({ ...inputErrors, startingDate: false });
                  }}
                  dateFormat="dd/mm/yy"
                  className="w-full"
                  showTime={false}
                  firstDayOfWeek={1}
                />
                {inputErrors.startingDate && (
                  <small style={{ color: "red" }}>
                    Lütfen ilk kayıt tarihi giriniz .
                  </small>
                )}
              </div>
              <Calendar
                placeholder="Yenileme Tarihi"
                locale="tr"
                className="w-full"
                style={{
                  border: "1px solid gray",
                  padding: "0.5rem",
                  marginBottom: "1rem",
                  borderRadius: "6px 6px 6px 6px",
                }}
                value={renewalDate}
                onChange={(e) => {
                  setRenewalDate(e.value);
                  setInputErrors({ ...inputErrors, renewalDate: false });
                }}
                dateFormat="dd/mm/yy"
                showTime={false}
                firstDayOfWeek={1}
              />
              {inputErrors.renewalDate && (
                <small style={{ color: "red" }}>
                  Lütfen yenileme tarihi giriniz .
                </small>
              )}
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "1rem",
          }}
        >
          <Button
            label="Ekle"
            disabled={isButtonDisable}
            onClick={newCreate}
            style={{ width: "15%" }}
            className="btn-excel-two"
          />
        </div>
      </Dialog>
      <Dialog
        visible={displayDeleteDialog}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        style={{ width: "60vw" }}
        header="Hosting Sil"
        onHide={hideDeleteDialog}
        modal
      >
        <div className="confirmation-content">
          <div style={{ display: "flex", justifyContent: "center" }}>
            <p>Hosting Silmek İstediğinize Emin Misiniz?</p>
          </div>
          <div className="confirmation-content">
          
            <div className="confirmation-content">
              <div className="field">
                <label htmlFor="name" className="font-bold">
                  Alan Adı: {domainName}
                </label>
              </div>
              
              <div className="field">
                <label htmlFor="name" className="font-bold">
                  Müşteri: {cus}
                </label>
              </div>
            </div>
           
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "1rem",
            }}
          >
            <Button
              label="Hayır"
              onClick={hideDeleteDialog}
              className="btn-excel-two"
              style={{ marginRight: "1rem" }}
            />
            <Button
              label="Evet"
              onClick={handleDeletedHosting}
              className="btn-excel-two"
            />
          </div>
        </div>
      </Dialog>
      <Dialog
        header="Pasife Al"
        visible={visibilityDialog}
        style={{ width: "50vw" }}
        onHide={() => setVisibilityDialog(false)}
        footer={
          <div>
            <Button
              label="Kapat"
              icon="pi pi-times"
              onClick={handleCloseDialog}
              className="btn-excel-two"
            />
            <Button
              label="Hosting Pasife Al"
              icon="pi pi-check"
              onClick={handleCompleteVisibile}
              className="btn-excel-two"
              style={{ marginLeft: "15px" }}
            />
          </div>
        }
      ></Dialog>
      <Toast ref={toast} />
    </Flex>
  );
}
